import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_FORBIDDEN',
    statusCode: 401,
    message: {
        en: '沒有權限',
    },
} as CustomErrorType;